// extracted by mini-css-extract-plugin
module.exports = {"loader":"LdlhE","header-image":"jrxDu","nav-container":"jh8nb","missing-menu":"S4rnJ","footer":"T1I1w","footer-link":"_9xL6Q","header":"KdAqt"};